export const indexLang = {
    title: {
        'en': 'BUY $ARTY TOKENS',
        'fr': 'ACHETER DES JETONS $ARTY',
        'de': '$ARTY-TOKEN KAUFEN',
        'ko': '$ARTY 토큰 구매',
        'ch': '购买 $ARTY 代币',
        'ru': 'КУПИТЬ ТОКЕНЫ $ARTY',
        'it': 'COMPRA TOKEN $ARTY',
        'jap': '$ARTYトークンの購入',
        'port': 'COMPRAR $ARTY TOKENS',
        'turk': '$ARTY TOKEN AL',
        'viet': 'MUA TOKEN ARTY$',
        'spa': 'COMPRAR TOKENS $ARTY',
        'arab': 'شراء $ARTY'
    },
    title2: {
        'en': '(VIDEO',
        'fr': '(',
        'de': '(',
        'ko': '(비디오',
        'ch': '(',
        'ru': '(',
        'it': '(VIDEO',
        'jap': '（ビデオ',
        'port': '(VIDEO',
        'turk': '(VİDEO',
        'viet': '(VIDEO',
        'spa': '(VIDEO',
        'arab': '(فيديو'
    },
    title3: {
        'en': 'GUIDE',
        'fr': 'Guide vidéo',
        'de': 'Videoanleitung',
        'ko': '지침',
        'ch': '视频指南',
        'ru': 'Видеоинструкция',
        'it': 'GUIDA',
        'jap': 'ガイド',
        'port': 'GUIA',
        'turk': 'rehber',
        'viet': 'Hướng DẪN',
        'spa': 'GUIAR',
        'arab': 'دليل'
    },
    support: {
        'en': 'After your transfer confirmed, your will see your $ARTY tokens on your balance in Launchpad account.',
        'fr': 'Une fois la transaction confirmée, vos jetons $ARTY seront crédités sur le solde de votre compte.',
        'de': 'Nach der Bestätigung der Transaktion werden Ihre $ARTY Ihrem Kontostand gutgeschrieben.',
        'ko': '트랜잭션이 확인 된 후,당신의$예술적인 토큰은 계정 잔액에 적립됩니다.',
        'ch': '交易确认后，您的$ARTY代币将记入您的帐户余额。',
        'ru': 'После подтверждения транзакции ваши $ARTY зачислятся на баланс вашего аккаунта.',
        'it': 'Una volta confermato il pagamento, vedrai i tuoi token $ARTY nel saldo del tuo account.',
        'jap': '決済が確認されると、口座残高に$ARTYトークンが表示されます。',
        'port': 'Assim que seu pagamento for confirmado, você verá seus tokens $ARTY em saldo em sua conta.',
        'turk': 'Ödemeniz onaylandıktan sonra, $ARTY tokenleriniz hesabınızdaki bakiyenizde görünecektir.',
        'viet': 'Sau khi thanh toán của bạn được xác nhận, bạn sẽ thấy các token ARTY$ của mình trên số dư tài khoản.',
        'spa': 'Cuando hayamos confirmado tu pago, tus tokens $ARTY aparecerán en el saldo de tu cuenta.',
        'arab': 'بمجرد تأكيد الدفع الخاص بك، سترى عملة ARTY$ ا ستكون قادرًا على سح'
    },
    support2: {
        'en': 'You will be able to withdraw your $ARTY tokens after the Token Generation Event (TGE). ',
        'fr': 'Vous pourrez retirer vos jetons $ARTY après lÉvénement de Génération de jetons (TGE).',
        'de': 'Sie können Ihre $ ARTY-Token nach dem Token Generation Event (TGE) abheben.',
        'ko': '토큰 생성 이벤트 후에$ARTY 토큰을 인출 할 수 있습니다 (TGE). ',
        'ch': '如有任何问题，您将能够在令牌生成事件（TGE）',
        'ru': 'Вы сможете вывести свои токены $ARTY после дня генерации токенов (TGE).',
        'it': 'Sarai in grado di ritirare i tuoi token $ARTY dopo l`Eevento di Generazione Token (EGT).',
        'jap': 'トークン生成イベント（TGE：Token Generation Event）後に、保有している$ARTYトークンが出金可能となります。',
        'port': 'Você poderá retirar seus tokens $ARTY após o evento de geração de tokens (TGE).',
        'turk': 'Token Üretme Etkinliği sonrasında (TGE) $ARTY tokenlerinizi geri çekebilirsiniz.',
        'viet': 'Bạn sẽ có thể rút các token ARTY$ sau Sự kiện tạo token (TGE). ',
        'spa': 'Podrás retirar tus tokens $ARTY después del Evento de Generación de Fichas (TGE).',
        'arab': 'ستكون قادرًا على سحب$ ARTY بعد حدث إنشاء الرمز المميز (TGE Token Generation Event).'
    },
    support3: {
        'en': 'For any questions please contact our',
        'fr': 'Pour toute question, veuillez contacter notre service',
        'de': 'Bei Fragen wenden Sie sich bitte an unseren',
        'ko': '질문이 있으시면 지원 팀에',
        'ch': '后提取您的$ARTY令牌。',
        'ru': 'По любым вопросам пожалуйста обращайтесь в нашу',
        'it': 'Per qualsiasi domanda contatta il nostro',
        'jap': 'ご不明な点がありましたらサポートまでお問い合わせく',
        'port': 'Qualquer dúvida entre em contato com nosso',
        'turk': 'Tüm sorularınız için lütfen destek birimimize',
        'viet': 'Nếu có bất cứ câu hoi nào, vui lòng liên hệ với đội ngũ hỗ trợ',
        'spa': 'Si tienes alguna pregunta, contacta con nuestro servicio',
        'arab': 'أسئلة يرجى الاتصال بدعمنا.'
    },
    support4: {
        'en': 'support',
        'fr': 'dassistance',
        'de': 'Support',
        'ko': '문의하십시오',
        'ch': '请联系我们的支持。',
        'ru': 'поддержку',
        'it': 'supporto',
        'jap': 'ださい。',
        'port': 'suporte',
        'turk': 'ulaşın',
        'viet': 'của chúng tôi',
        'spa': 'de soporte',
        'arab': 'لأية'
    },
    accept: {
        'en': 'We Accept:',
        'fr': 'Nous acceptons:',
        'de': 'Wir akzeptieren:',
        'ko': '허용:',
        'ch': '我们接受：',
        'ru': 'Мы принимаем:',
        'it': 'Accettiamo:',
        'jap': '対応',
        'port': 'Nós aceitamos:',
        'turk': 'Kabul Edilir:',
        'viet': 'Chúng tôi chấp nhận:',
        'spa': 'Aceptamos:',
        'arab': 'نحن نقبل:'
    },
    current_round: {
        'en': 'CURRENT ROUND',
        'fr': 'CYCLE EN COURS',
        'de': 'AKTUELLE RUNDE',
        'ko': '현재 라운드',
        'ch': '当前轮',
        'ru': 'ТЕКУЩИЙ РАУНД',
        'it': 'TURNO IN CORSO',
        'jap': '現在のラウンド',
        'port': 'RODADA ATUAL',
        'turk': 'MEVCUT TUR',
        'viet': 'VÒNG HIỆN TẠI',
        'spa': 'RONDA ACTUAL',
        'arab': 'الجولة الحالي'
    },
    token_info: {
        'en': '$ARTY TOKEN INFORMATION',
        'fr': 'INFORMATIONS RELATIVES AU JETON $ARTY',
        'de': '$ARTY-TOKEN-INFORMATIONEN',
        'ko': '$ARTY 토큰 정보',
        'ch': '$ARTY 代币信息',
        'ru': 'ИНФОРМАЦИЯ О ТОКЕНЕ $ARTY ',
        'it': 'INFORMAZIONI SUL TOKEN $ARTY',
        'jap': '$ARTYトークンの情報',
        'port': 'INFORMAÇÃO $ARTY TOKEN',
        'turk': '$ARTY TOKEN BİLGİSİ',
        'viet': 'THÔNG TIN TOKEN ARTY$',
        'spa': 'INFORMACIÓN SOBRE EL TOKEN $ARTY',
        'arab': 'معلومات عن $ARTY'
    },
    token_info2: {
        'en': '$ARTY token is used as the internal currency and governance token on the Artyfact platform. You can use it to pay for any platform services, receive rewards by staking $ARTY, get premium privileges and vote on proposed improvements to the Artyfact platform.',
        'fr': 'Le jeton $ARTY est utilisé comme devise interne et jeton de gouvernance sur la plateforme Artyfact. Vous pouvez lutiliser pour payer nimporte quel service sur la plateforme, recevoir des récompenses en plaçant vos jetons $ARTY en staking, obtenir des privilèges Premium et voter pour les améliorations proposées sur la plateforme Artyfact.',
        'de': 'Das $ARTY-Token wird als interne Währung und Governance-Token der Artyfact-Plattform verwendet. Sie können damit für alle Dienstleistungen der Plattform bezahlen, durch das Staking von $ARTY Belohnungen verdienen, Premium-Privilegien erhalten und über Verbesserungsvorschläge für die Artyfact-Plattform abstimmen.',
        'ko': '$ARTY 토큰은 Artyfact 플랫폼에서 내부 통화 및 거버넌스 토큰으로 사용됩니다. 이를 사용하여 모든 플랫폼 서비스를 결제하고, $ARTY을(를) 스테이킹하여 보상을 받고, 프리미엄 특혜를 받으며, Artyfact 플랫폼에 대해 제안된 개선 사항에 투표할 수 있습니다.',
        'ch': '$ARTY 代币在 Artyfact 平台上用作内部货币和治理代币。您可以使用它来支付任何平台服务的费用，通过质押 $ARTY 获得奖励，获得高级特权并对 Artyfact 平台的改进建议进行投票。',
        'ru': 'Токен $ARTY используется как внутренняя валюта и токен управления в экосистеме Artyfact. Вы можете использовать его для оплаты любых услуг платформы, управления Artyfact DAO, получения вознаграждений за стейкинг $ARTY, получения премиальных привилегий и голосования за предлагаемые улучшения платформы Artyfact.',
        'it': 'Il token $ARTY viene utilizzato come valuta interna e token di gestione sulla piattaforma Artyfact. Puoi usarlo per pagare qualsiasi servizio della piattaforma, ricevere ricompense mettendo $ARTY in staking, ottenere privilegi premium e votare sui miglioramenti proposti alla piattaforma Artyfact.',
        'jap': '$ARTYトークンは、Artyfactプラットフォーム上の共通通貨およびガバナンストークンとして使用されています。プラットフォームのサービスへの支払い、$ARTYを賭けた報酬の受け取り、プレミアムな特権の獲得、Artyfactプラットフォームの改善提案に関する投票に使用することができます。',
        'port': 'O token $ARTY é usado como moeda interna e token de governança na plataforma Artyfact. Você pode usá-lo para pagar por qualquer serviço da plataforma, receber prêmios apostando $ARTY, obter privilégios premium e votar nas melhorias propostas para a plataforma Artyfact.',
        'turk': '$ARTY Artyfact platformunun yerli para birimi ve yönetişim tokeni olarak kullanılır. Tokeni kullanarak platformdaki tüm hizmetler için ödeme yapabilir, $ARTY hissesi alarak ödüller kazanabilir, özel imtiyazlar elde edebilir ve Artyfact platformu için önerilen iyileştirmelere oy verebilirsiniz.',
        'viet': 'Token ARTY$ được sử dụng như một đồng tiền tệ nội bộ và quản trị trên nền tảng Arty. Bạn có thể sử dụng để thanh toán bất cứ dịch vụ nền tảng nào, nhận thưởng bằng cách stake ARTY$, nhận những lợi ích cao cấp và bỏ phiếu về các cải tiến được đề xuất cho nền tảng Artyfact.',
        'spa': 'El token $ARTY es la moneda que se utiliza dentro de la plataforma Artyfact. Puedes utilizarlo para pagar cualquier servicio de la plataforma, recibir recompensas apostando $ARTY, obtener privilegios premium y votar sobre las mejoras propuestas para la plataforma Artyfact.',
        'arab': 'يتم استخدام $ARTY كعملة داخلية ورمز للحوكمة على منصة أرتيفاكت. يمكنك استخدامه للدفع مقابل أي خدمة على المنصة، والحصول على مكافآت من خلال تجميع $ARTY، والحصول على امتيازات والتصويت على التحسينات المقترحة لمنصة أرتيفاكت.'
    },
    token_info3: {
        'en': 'Build on the Binance Smart Chain (BEP20);',
        'fr': 'Basé sur la Binance Smart Chain (BEP20) ;',
        'de': 'Entwickelt auf Binance Smart Chain (BEP20);',
        'ko': '바이낸스 스마트 체인(BEP20)을 기반으로 구축',
        'ch': '基于币安智能链 (BEP20)；',
        'ru': 'Разработан на Binance Smart Chain (BEP20);',
        'it': 'Realizzato sulla Binance Smart Chain (BEP20);',
        'jap': 'バイナンススマートチェーン（BEP20）上に構築',
        'port': 'Construir na Binance Smart Chain (BEP20);',
        'turk': 'Binance Akıllı Zinciri (BEP20) temellidir;',
        'viet': 'Xây dựng trên Binance Smart Chain (BEP20);',
        'spa': 'Desarrolla en la cadena inteligente de Binance (BEP20);',
        'arab': 'البناء على سلسلة Binance الذكية (BEP20)؛'
    },
    token_info4: {
        'en': 'Maximum supply of 25 million ARTY;',
        'fr': 'Offre maximale de 25 millions de jetons ARTY ;',
        'de': 'Maximales Angebot von 25 Millionen ARTY;',
        'ko': '최대 25억 ARTY 공급',
        'ch': 'ARTY 的供应上限为 25 亿；',
        'ru': 'Максимальное количество - 25 миллионов $ARTY;',
        'it': 'Fornitura massima di 25 milioni di $ARTY;',
        'jap': '最高で1億$ARTYを供給',
        'port': 'Fornecimento máximo de 25 milhões de $ARTY;',
        'turk': 'Azami arz 25 milyon $ARTY;',
        'viet': 'Nguồn cung tối đa 25 triệu ARTY$;',
        'spa': 'Suministro máximo de 25 millones de $ARTY;',
        'arab': 'العرض الأقصى 25 مليون ARTY$؛'
    },
    token_info5: {
        'en': 'The token is not reissued;',
        'fr': 'Le jeton nest pas réémis;',
        'de': 'Das Token wird nicht neu ausgegeben;',
        'ko': '토큰은 재발행 불가',
        'ch': '代币不补发；',
        'ru': 'Токен не перевыпускается;',
        'it': 'Il token non viene rilasciato;',
        'jap': 'トークンは再発行なし',
        'port': 'O token não é reemitido;',
        'turk': 'Token tekrar düzenlenmez;',
        'viet': 'Token này không được cấp phát lại;',
        'spa': 'El token no se vuelve a emitir;',
        'arab': 'لم يتم إعادة إصدار العملة'
    },
    token_info6: {
        'en': 'Rewards for staking;',
        'fr': 'Récompenses de staking;',
        'de': 'Belohnungen für Staking;',
        'ko': '스테이킹 보상',
        'ch': '质押奖励；',
        'ru': 'Награды за стейкинг;',
        'it': 'Ricompense per lo staking;',
        'jap': '賭けに対する報酬',
        'port': 'Prêmios por staking;',
        'turk': 'Hisse alma ödülleri;',
        'viet': 'Phần thưởng khi stake;',
        'spa': 'Recompensas por "staking";',
        'arab': 'مكافآت التخزين؛'
    },
    token_info7: {
        'en': 'Burning function;',
        'fr': 'Fonction de destruction (burning);',
        'de': 'Burning-Funktion;',
        'ko': '소각 기능',
        'ch': '焚毁功能；',
        'ru': 'Функция сжигания;',
        'it': 'Funzione di distruzione;',
        'jap': 'バーン機能',
        'port': 'Função de queima;',
        'turk': 'Yakma işlevi;',
        'viet': 'Chức năng đốt;',
        'spa': 'Función de "burning";',
        'arab': 'عملية الحرق؛'
    },
    token_info8: {
        'en': 'Privileges for token holders.',
        'fr': 'Privilèges pour les détenteurs de jetons.',
        'de': 'Privilegien für Token-Inhaber.',
        'ko': '토큰 보유자를 위한 특혜입니다.',
        'ch': '代币持有者的特权。',
        'ru': 'Привилегии для холдеров токена.',
        'it': 'Privilegi per i possessori di token.',
        'jap': 'トークン保有者の特権',
        'port': 'Privilégios para titulares de tokens.',
        'turk': 'Token sahipleri için imtiyazlar.',
        'viet': 'Các đặc quyền cho người nắm giữ token.',
        'spa': 'Privilegios para los poseedores de tokens.',
        'arab': 'امتيازات لحاملي العملة.'
    },
    sale_events: {
        'en': 'TOKEN SALE EVENTS',
        'fr': 'Événements de vente de jetons',
        'de': 'Token-Sale-Events',
        'ko': '토큰 판매 이벤트',
        'ch': '代币销售活动',
        'ru': 'Мероприятия по продаже токена',
        'it': '',
        'jap': '',
        'port': '',
        'turk': '',
        'viet': '',
        'spa': '',
        'arab': ''
    },
    seed: {
        'en': 'Seed Sale',
        'fr': 'Vente de seed',
        'de': 'Seed-Sale',
        'ko': '시드 판매',
        'ch': '种子销售',
        'ru': 'Seed Sale',
        'it': '',
        'jap': '',
        'port': '',
        'turk': '',
        'viet': '',
        'spa': '',
        'arab': ''
    },
    ongoing: {
        'en': 'ongoing',
        'fr': 'en cours',
        'de': 'läuft',
        'ko': '계속',
        'ch': '正在进行',
        'ru': 'в процессе',
        'it': '',
        'jap': '',
        'port': '',
        'turk': '',
        'viet': '',
        'spa': '',
        'arab': ''
    },
    supply: {
        'en': '% of total supply',
        'fr': '% de loffre totale',
        'de': '% des Gesamtangebots',
        'ko': '총 공급량 중 %',
        'ch': '占总供应量的百分比',
        'ru': '% от общего количества',
        'it': '',
        'jap': '',
        'port': '',
        'turk': '',
        'viet': '',
        'spa': '',
        'arab': ''
    },
    min_invest: {
        'en': 'Min. investment',
        'fr': 'Investissement minimal',
        'de': 'Mindestinvestition',
        'ko': '최소 투자',
        'ch': '最小投资',
        'ru': 'Мин. инвестиция',
        'it': '',
        'jap': '',
        'port': '',
        'turk': '',
        'viet': '',
        'spa': '',
        'arab': ''
    },
    max_invest: {
        'en': 'Max. investment',
        'fr': 'Investissement maximal',
        'de': 'Höchstinvestition',
        'ko': '최대 투자',
        'ch': '最大投资',
        'ru': 'Макс. инвестиция',
        'it': '',
        'jap': '',
        'port': '',
        'turk': '',
        'viet': '',
        'spa': '',
        'arab': ''
    },
    private_sale: {
        'en': 'Private sale',
        'fr': 'Vente privée',
        'de': 'Privatverkauf',
        'ko': '비공개 판매',
        'ch': '私人出售',
        'ru': 'Приватный сейл',
        'it': '',
        'jap': '',
        'port': '',
        'turk': '',
        'viet': '',
        'spa': '',
        'arab': ''
    },
    presale: {
        'en': 'Presale',
        'fr': 'Prévente',
        'de': 'Vorverkauf',
        'ko': '사전 판매',
        'ch': '预售',
        'ru': 'Предпродажа',
        'it': '',
        'jap': '',
        'port': '',
        'turk': '',
        'viet': '',
        'spa': '',
        'arab': ''
    },
    public_sale: {
        'en': 'Public sale',
        'fr': 'Vente publique',
        'de': 'Öffentlicher Verkauf',
        'ko': '공개 판매',
        'ch': '公开出售',
        'ru': 'Публичная продажа',
        'it': '',
        'jap': '',
        'port': '',
        'turk': '',
        'viet': '',
        'spa': '',
        'arab': ''
    },
    more_info: {
        'en': 'More information soon',
        'fr': 'Plus dinformations bientôt',
        'de': 'Weitere Informationen in Kürze',
        'ko': '추가 정보 제공 예정',
        'ch': '更多信息即将发布',
        'ru': 'Подробная информация скоро',
        'it': '',
        'jap': '',
        'port': '',
        'turk': '',
        'viet': '',
        'spa': '',
        'arab': ''
    },
}